module.exports = __webpack_public_path__ + "img/printer-fill.54c4b371.svg";